<!-- ── Dialog header ─────────────────────────────── -->
<div class="dialog-header">
  <mat-icon class="header-icon">edit_calendar</mat-icon>
  <h2>Edit Template</h2>
</div>

<mat-dialog-content>
  <form [formGroup]="slotsForm">

    <!-- Template name -->
    <mat-form-field appearance="outline" class="w-100 mb-2">
      <mat-label>Template name</mat-label>
      <mat-icon matPrefix class="form-prefix-icon">label</mat-icon>
      <input matInput formControlName="name" placeholder="e.g. ToArlanda" />
    </mat-form-field>

    <!-- Date range (only for Always-assignment templates) -->
    <ng-container *ngIf="currentPeriod">
      <div class="section-label">Date range</div>
      <div class="date-range-row">
        <mat-form-field appearance="outline" class="date-field">
          <mat-label>Start date</mat-label>
          <mat-icon matPrefix class="form-prefix-icon">event</mat-icon>
          <input matInput type="date" formControlName="dateFrom" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="date-field">
          <mat-label>End date</mat-label>
          <mat-icon matPrefix class="form-prefix-icon">event</mat-icon>
          <input matInput type="date" formControlName="dateTo" />
        </mat-form-field>
      </div>
    </ng-container>

    <!-- Error banner -->
    <div *ngIf="error" class="error-banner">
      <mat-icon>error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>

    <!-- ── Slots ──────────────────────────────── -->
    <div formArrayName="slots">
      <mat-card *ngFor="let slot of slots.controls; let i = index" [formGroupName]="i" class="slot-card mb-3">

        <mat-card-content>

          <!-- Time + Presets + Delete -->
          <div class="slot-top-row">

            <mat-form-field appearance="outline" class="time-field">
              <mat-label>Time</mat-label>
              <mat-icon matPrefix class="form-prefix-icon-time">schedule</mat-icon>
              <input matInput type="time" formControlName="time" />
            </mat-form-field>

            <div *ngIf="presets.length" class="presets-area">
              <div class="presets-label">Quick presets</div>
              <div class="preset-chips">
                <button mat-stroked-button class="preset-chip" type="button" *ngFor="let preset of presets"
                  (click)="applyPreset(i, preset)" [matTooltip]="preset.label">
                  {{ preset.label }}
                </button>
              </div>
            </div>

            <button mat-icon-button class="delete-slot-btn" type="button" matTooltip="Remove this slot"
              (click)="removeSlot(i)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>

          <!-- Reserved Seats + Start Offset side-by-side -->
          <div class="seats-grid">

            <!-- Reserved Seats -->
            <div class="section-panel reserved">
              <div class="section-header">
                <mat-icon>airline_seat_recline_normal</mat-icon>
                <h6>Reserved Seats</h6>
              </div>
              <div formArrayName="reservedSeats">
                <div *ngFor="let entry of getReservedSeats(i).controls; let j = index" [formGroupName]="j"
                  class="entry-row">
                  <mat-form-field appearance="outline" class="name-field">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="count-field">
                    <mat-label>Count</mat-label>
                    <input matInput type="number" min="0" formControlName="count" />
                  </mat-form-field>
                  <button mat-icon-button class="delete-entry-btn" type="button"
                    (click)="removeEntry(i, 'reservedSeats', j)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
              <button mat-stroked-button class="add-entry-btn" type="button" (click)="addEntry(i, 'reservedSeats')">
                <mat-icon>add</mat-icon> Add seat
              </button>
            </div>

            <!-- Mobile-only divider between stacked panels -->
            <span class="section-divider"></span>

            <!-- Start Offset -->
            <div class="section-panel offset">
              <div class="section-header">
                <mat-icon>timer</mat-icon>
                <h6>Start Offset</h6>
              </div>
              <div formArrayName="startOffset">
                <div *ngFor="let entry of getStartOffset(i).controls; let j = index" [formGroupName]="j"
                  class="entry-row">
                  <mat-form-field appearance="outline" class="name-field">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="count-field">
                    <mat-label>Count</mat-label>
                    <input matInput type="number" min="0" formControlName="count" />
                  </mat-form-field>
                  <button mat-icon-button class="delete-entry-btn" type="button"
                    (click)="removeEntry(i, 'startOffset', j)">
                    <mat-icon class="close-icon-offset">close</mat-icon>
                  </button>
                </div>
              </div>
              <button mat-stroked-button class="add-entry-btn" type="button" (click)="addEntry(i, 'startOffset')">
                <mat-icon>add</mat-icon> Add offset
              </button>
            </div>

          </div><!-- /seats-grid -->
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Add slot -->
    <div class="add-slot-row">
      <button mat-mini-fab color="primary" type="button" (click)="addSlot()" matTooltip="Add a new time slot">
        <mat-icon>add</mat-icon>
      </button>
      <span>Add time slot</span>
    </div>

  </form>
</mat-dialog-content>

<!-- ── Actions ───────────────────────────────── -->
<mat-dialog-actions [align]="'end'" class="dialog-actions-divider">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!slotsForm.valid">
    <mat-icon>save</mat-icon>&nbsp;Save
  </button>
</mat-dialog-actions>